import { has } from 'lodash';
import { map } from 'rxjs/operators';

/**
 * Rxjs Operator to fill out missing data required by the data loader to
 * work correctly. This also rearranges the resulting data to the requested
 * sequence by the dataloader.
 *
 * @param input The array of keys from dataloader.
 * @param getId Get a unique id for the loader to work with.
 * @param createError Function to create an error if one of the inputs is not found.
 */
export function normalizeForLoader<T extends any[]>(
  input: string[],
  getId: (record: T[number]) => string,
  createError: (id: string) => Error = () => new Error('No Record found!')
) {
  return map<T, (T[number] | Error)[]>(data => {
    // Re-arrange the data for correct sequence and clear for errors.
    const single = Object.fromEntries(data.map((d: T[number]) => [getId(d), d]));
    return input.map(id => (has(single, id) ? single[id] : createError(id))) as T;
  });
}
